/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './categories';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "categories": {
                "nested": {
                  "ListCategoriesRequest": {
                    "fields": {}
                  },
                  "UpdateCategoryRequest": {
                    "fields": {
                      "idempotenceToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "transactionCategory": {
                        "type": ".squareup.bbfrontend.common.categories.TransactionCategory",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.categories?.nested?.ListCategoriesRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.categories?.nested?.UpdateCategoryRequest) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListCategoriesRequest @ squareup/bbfrontend/common/categories/categories_requests.proto at 12:1
 */
export const ListCategoriesRequest = $root.lookupType('squareup.bbfrontend.common.categories.ListCategoriesRequest');
fixType(ListCategoriesRequest);
Builder.createAndAttachToType(ListCategoriesRequest);
/**
 * SOURCE UpdateCategoryRequest @ squareup/bbfrontend/common/categories/categories_requests.proto at 14:1
 */
export const UpdateCategoryRequest = $root.lookupType('squareup.bbfrontend.common.categories.UpdateCategoryRequest');
fixType(UpdateCategoryRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  transactionCategory: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateCategoryRequest);